import { linkParsing } from 'Lib/link-parsing/link-parsing';
import { eventSender } from 'Lib/event-sender/event-sender';
import { isTouch } from 'Lib/istouch/istouch';

const $test = $('.test');
const nameTest = $('title').text().trim();
const dataNextAuto = $test.attr('data-next-auto');
const dataViewRight = $test.attr('data-view-right');
const dataCalcType = $test.attr('data-calc-type');
const dataResultLinkAnchor = $test.attr('data-result-anchor');
const TestText = function (params) {
    const thisTestText = this;
    const sStep = '.test__step';
    const sQuestion = '.test-question';
    const sAnswer = '.test__answer';
    const $btnStart = $('.test__btn-start');
    const sBtnNext = '.test__btn-next';
    const $loader = $('.test__loader');
    const cLoaderActive = 'test__loader_active';
    const cSelected = 'selected';
    let balls = 0;
    const maxBalls = 1000;

    thisTestText.Ansvers = {};
    thisTestText.params = params;

    thisTestText.Answer = function (el) {
        const $el = $(el);
        let q = $el.attr('data-question');
        let a = $el.attr('data-answer');
        const $curStep = $el.closest(sStep);

        if (thisTestText.Ansvers[q]) {
            return;
        }

        thisTestText.Ansvers[q] = a;

        if (thisTestText.params.VIEW_RIGHT || (!thisTestText.params.VIEW_RIGHT && !thisTestText.params.NEXT_AUTO)) {
            $loader.addClass(cLoaderActive);

            $.get('./', { q, a, action: 'is_right' }, (d) => {
                let data = d;
                const aAns = [];
                const aComments = [];

                if (typeof data !== 'object') {
                    data = $.parseJSON(data);
                }

                $curStep.find(sQuestion).each(function () {
                    q = $(this).attr('data-question');
                    a = $(this).attr('data-answer');

                    if (!aAns[q]) {
                        aAns[q] = [];
                    }

                    aAns[q][a] = this;
                });

                $curStep.find(sAnswer).each(function () {
                    q = $(this).attr('data-question');
                    a = $(this).attr('data-answer');

                    if (!aComments[q]) {
                        aComments[q] = [];
                    }

                    aComments[q][a] = this;
                });

                for (let i = 0; i < data.length; i++) {
                    q = data[i].Q;
                    a = data[i].A;
                    $(aComments[q][a]).html(data[i].COMMENT);

                    if (data[i].COMMENT !== '') {
                        $(aComments[q][a]).css('display', 'block');
                    }

                    if (thisTestText.params.VIEW_RIGHT) {
                        if (a === $el.attr('data-answer')) {
                            if (Number(data[i].R) === 0) {
                                $(aAns[q][a]).addClass('fail');
                            }
                        } else {
                            $(aAns[q][a]).addClass('test-question_grey');
                        }

                        if (Number(data[i].R) === 1) {
                            $(aAns[q][a]).removeClass('fail').removeClass('test-question_grey').addClass('right');
                        }
                    } else {
                        $(aAns[q][a]).addClass('test-question_grey');
                    }
                }

                $loader.removeClass(cLoaderActive);
                $el.removeClass('test-question_grey').addClass(cSelected);
                thisTestText.ViewNextStep(el);
            });
        } else if (thisTestText.params.CALC_TYPE_BALLS) {
            $.get('./', { q, a, action: 'is_right' }, (d) => {
                let data = d;

                if (typeof data !== 'object') {
                    data = $.parseJSON(data);
                }

                let curBalls = data[0].B;

                if (Number.isNaN(curBalls)) {
                    curBalls = 0;
                }

                curBalls = parseInt(curBalls);
                balls += curBalls;
                $el.addClass(cSelected);
                thisTestText.ViewNextStep(el);
            });
        } else {
            $el.addClass(cSelected);
            thisTestText.ViewNextStep(el);
        }
    };

    thisTestText.ViewNextStep = function (seletedAnswerEl, formStep) {
        const isFormStep = typeof formStep === 'boolean' ? formStep : false;
        const step = $($(seletedAnswerEl).closest(sStep));
        const stepNum = Number(step.attr('id'));
        const nextStepNum = stepNum + 1;
        const $ballroundText = $('.test__ballround-text');
        const $ballroundSvg = $('.test__ballround-svg');

        if (thisTestText.params.MOD === 'pofig-calc' && $ballroundText.length && $ballroundSvg.length) {
            const hours = Math.floor(balls / 60);
            const minutes = Math.floor(balls % 60);
            const roundNum = 315;

            $ballroundText.first().html(`${hours}ч ${minutes}м`);
            $ballroundSvg.css({ 'stroke-dasharray': `${Math.round((roundNum / maxBalls) * balls)} ${roundNum}` });
        }

        if (isFormStep) {
            thisTestText.ViewStep(nextStepNum);
        } else if (thisTestText.params.NEXT_AUTO) {
            setTimeout(() => {
                thisTestText.ViewStep(nextStepNum);
            }, 700);
        } else {
            $(sBtnNext, step).removeClass('btn_disabled');

            $(sBtnNext, step).click(() => {
                thisTestText.ViewStep(nextStepNum);
            });
        }
    };

    thisTestText.ViewStep = function (n) {
        const num = n;
        let find = false;

        $(sStep).each(function () {
            const id = parseInt($(this).attr('id'));

            if (id === num - 1) {
                $(this).slideUp();
            }

            if (id === num) {
                find = true;
                $(this).slideDown();

                if (isTouch() && !$test.hasClass('test_no-scroll')) {
                    $('html, body').animate({ scrollTop: 50 }, 500);
                }

                $(sQuestion, this).click(function () {
                    if (!$(this).closest(sStep).find(`${sQuestion}.${cSelected}`).length) {
                        thisTestText.Answer(this);
                    }
                });
            }
        });

        if (!find) {
            if (thisTestText.params.MOD === 'pofig-calc') {
                $('.test__ballround').remove();
            }

            thisTestText.Finish();
        }
    };

    thisTestText.Finish = function () {
        $loader.addClass(cLoaderActive);

        $.post('./', { ANSVERS: thisTestText.Ansvers, action: 'finish', BALLS: balls }, (d) => {
            let data = d;
            let additionParams = '';

            if (thisTestText.params.MOD === 'pofig-calc') {
                additionParams += `&balls=${balls}`;
            }

            data = Number(data);
            document.location = `?r=${data}${additionParams}${dataResultLinkAnchor ? `#${dataResultLinkAnchor}` : ''}`;
        });
    };

    thisTestText.Init = function () {
        $btnStart.click(function () {
            $(this).closest('.ganre').css({ 'background-image': 'none' });
            thisTestText.ViewStep(1);

            if (thisTestText.params.MOD === 'pofig-calc') {
                setTimeout(() => {
                    $test.append('<div class="test__ballround"><svg class="test__ballround-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="none"></circle></svg><div class="test__ballround-content"><div class="test__ballround-title">Потратили:</div><div class="test__ballround-text">0ч 0м</div></div></div>');
                }, 700);
            }

            if (nameTest) {
                eventSender.customDL({
                    event: 'eksmo',
                    eventAction: 'test',
                    eventCategory: 'Пройти тест',
                    eventLabel: nameTest,
                });
            }
        });

        $('.test__subscribe-link').on('click', function (e) {
            const $curStep = $(this).closest(sStep);

            if ($curStep.length) {
                e.preventDefault();

                if (nameTest) {
                    eventSender.customDL({
                        event: 'eksmo',
                        eventAction: 'test',
                        eventCategory: 'Пропустить и посмотреть результат теста',
                        eventLabel: nameTest,
                    });
                }

                thisTestText.ViewNextStep($curStep, true);
            }
        });

        $('.test__subscribe-form').on('eksmoThisAjaxFormSuccess', function () {
            const $curStep = $(this).closest(sStep);

            if ($curStep.length) {
                thisTestText.ViewNextStep($curStep, true);
            }

            if (nameTest) {
                eventSender.customDL({
                    event: 'eksmo',
                    eventAction: 'engagement',
                    eventCategory: 'Подписка на рассылку',
                    eventLabel: nameTest,
                });
            }
        });

        $('.test').on('click', 'a', function () {
            const href = $(this).attr('href');

            if (typeof href === 'string' && href.length) {
                const nomcode = linkParsing.getBookNomcode(href);

                if (nomcode) {
                    eventSender.eventTestClickLink(nomcode);
                } else if (href.indexOf('book24.ru/') > -1) {
                    eventSender.customDL({ 'event': 'clickFiction' });
                } else if (href.indexOf('ozon.ru/') > -1) {
                    eventSender.customDL({ 'event': 'clickOzon' });
                } else if (href.indexOf('labirint.ru/') > -1) {
                    eventSender.customDL({ 'event': 'clickLabirint' });
                } else if (href.indexOf('chitai-gorod.ru/') > -1) {
                    eventSender.customDL({ 'event': 'clickChitaiGorod' });
                } else if (href.indexOf('litres.ru/') > -1) {
                    eventSender.customDL({ 'event': 'clickLitres' });
                } else if (href.indexOf('book24.ua/') > -1) {
                    eventSender.customDL({ 'event': 'clickBook24' });
                } else if (href.indexOf('elkniga.ru/') > -1) {
                    eventSender.customDL({ 'event': 'clickElkniga' });
                } else if (href.indexOf('mybook.ru/') > -1) {
                    eventSender.customDL({ 'event': 'clickMyBook' });
                }
            }
        });
    };
};
const test = new TestText({
    NEXT_AUTO: (typeof dataNextAuto === 'string' && dataNextAuto === 'Y'),
    VIEW_RIGHT: (typeof dataViewRight === 'string' && dataViewRight === 'Y'),
    CALC_TYPE_BALLS: (typeof dataCalcType === 'string' && (dataCalcType === 'BALL_SUMM' || dataCalcType === 'BALL_SUMM_INTERVAL_NEGATIVE')),
    MOD: $('.test_mod_pofig-calc').length ? 'pofig-calc' : '',
});

test.Init();